import { useKas } from "contexts/KasContext";
import posthog from "posthog-js";
import React, { useEffect } from "react";
import { prependKasUrl, redirectUserToLogin } from "server/kas/utils";
import { resetPostHogIdentity } from "utils/posthogFeatureFlags";

const Logout: React.FC = () => {
  const { isUserLoggedIn, isLoading, logout } = useKas();

  useEffect(() => {
    if (isLoading) return;

    if (!isUserLoggedIn) {
      resetPostHogIdentity(posthog);
      redirectUserToLogin();
      return;
    }

    fetch(prependKasUrl(`/v2/users/logout`), {
      method: "POST",
      credentials: "include",
    }).then(() => logout());
  }, [isLoading, isUserLoggedIn, logout]);

  return <></>;
};

export default Logout;
